import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=2c45bda5&scoped=true"
import script from "./payMethod.vue?vue&type=script&lang=js"
export * from "./payMethod.vue?vue&type=script&lang=js"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=2c45bda5&prod&lang=less&scoped=true"
import style1 from "./payMethod.vue?vue&type=style&index=1&id=2c45bda5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45bda5",
  null
  
)

export default component.exports